import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getBottleOrder } from "../../services/bottleOrderService";
import Slide from "react-reveal/Slide";
import OrderedBottle from "./OrderedBottle";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PageHeading from "../common/PageHeading";

const ToDate = (input) => {
  if (input) {
    let date = new Date(input);
    let output = date.toLocaleDateString();
    //handle default date from API
    if (date.getYear() === 1) return "";
    return output;
  } else {
    return "";
  }
};

// Module scope on purpose: a component declared inside another component is a
// new type on every render, so React remounts its subtree instead of updating it.
const Field = ({ label, value }) => (
  <Box sx={{ mb: 2 }}>
    <Typography
      variant="caption"
      sx={{ display: "block", fontWeight: 600, color: "text.secondary" }}
    >
      {label}
    </Typography>
    <Typography variant="body2">{value}</Typography>
  </Box>
);

export default function BottleOrder() {
  const { orderNumber } = useParams();
  const [order, setOrder] = useState();

  useEffect(() => {
    async function GetBottleOrder() {
      if (orderNumber) {
        let data = await getBottleOrder(orderNumber);
        setOrder(data);
      }
    }
    GetBottleOrder();
  }, [orderNumber]);


  return (
    <>
      {!order ? (
        <></>
      ) : (
        <Slide top>
          <Box sx={{ p: 2 }}>
            <PageHeading
              title={`# ${orderNumber}`}
              action={
                <Tooltip title="Close">
                  <IconButton component={Link} to="/" size="small">
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              }
            />

            <Card sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                  Information
                </Typography>
                <Divider sx={{ mb: 2 }} />

                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <Field label="Description" value={order.Description} />
                    <Field label="Type" value={order.SampleMatrix} />
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <Field label="Order Date" value={ToDate(order.OrderDate)} />
                    <Field
                      label="Ship to Client Date"
                      value={ToDate(order.DueDate)}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            <Card>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                  Bottles
                </Typography>
                <Divider sx={{ mb: 2 }} />
                {order.OrderedBottles?.map((s) => {
                  return <OrderedBottle key={s.LabId} bottle={s} />;
                })}
              </CardContent>
            </Card>
          </Box>
        </Slide>
      )}
    </>
  );
}
